export enum CadyMarket {
  CapGown = 'capgown',
  Graduation = 'graduation',
  Athletic = 'athletic',
  Underclass = 'underclass',
  Senior = 'senior'
}
